import React from "react";
import BlogImage from "../../../images/blog-banner.png";
import { Typography } from "src/components/shared";
import { highlightUnderscoreText } from "src/utils/utils";

type BlogHeaderData = {
  tagTitle: string;
  headerText?: string | null;
  backgroundImage?:{
    url:string;
    title:string
  }
};

type BlogHeaderProps = {
  blogPageHeaderData: BlogHeaderData | null;
};

const BlogHeader = ({ blogPageHeaderData }: BlogHeaderProps) => {
  if (!blogPageHeaderData) {
    return null;
  }

  const { tagTitle, headerText,backgroundImage } = blogPageHeaderData;

  return (
    <div className="hero-block">
      <div
        className="hero-banner-block hero-background"
        style={{ minHeight: "630px", maxHeight: "80vh" }}
       >
        <img src={backgroundImage?.url} alt="background" className="background-image" />
        <div className="container-fluid custom-spacer-col position-relative gap-5">
          <div className="hero-content-wrapper" style={{ marginTop: "200px" }}>
            <h1
              className="hero-title hero-title-custom light"
              dangerouslySetInnerHTML={{
                __html: highlightUnderscoreText(tagTitle ?? ""),
              }}
            />
            {headerText && (
              <Typography
                tag="p"
                className="hero-description text-center blog-desc light"
              >
                {headerText}
              </Typography>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogHeader;
